import React from 'react'
import Footer from '../common/Footer'
import ContactInfo from '../sections/ContactInfo'
import Services from '../sections/Services'
import Team from '../sections/Team'

function Cdsoft() {
    return (
        <>
            <div className="flex flex-col h-screen justify-between min-h-full">
                <header className="bg-white shadow">
                    <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                        <h1 className="text-3xl font-bold orange-144C">Centro de Desarrollo de Software (CDSOFT)</h1>
                    </div>
                </header>
                <main className="flex-grow">
                    <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                        <div className="px-4 py-4 sm:px-0">
                            <div className="text-justify p-2" >
                                {/* <img src="img/cdsoft.jpg" className="img-responsive img_centrar" alt="" /> */}
                                {/* <br />
                                <br /> */}
                                <div className="text-justify bg-blue-100 rounded-lg p-2" >
                                    El enfoque principal es el desarrollo de soluciones informáticas para unidades y departamentos que integran la Universidad, con el objetivo de mejorar los procesos que se realizan en la institución a nivel de Campus/Sedes. Así como también el estudiar nuevas tecnologías en el ámbito del desarrollo de aplicaciones que puedan resultar útiles a los procesos llevados a cabo por las unidades y departamentos, agregando valor a sus respectivos procesos.<br />
                                </div>
                            </div>
                            <Services />
                            <Team />
                            <ContactInfo />
                        </div>
                    </div>
                </main>
                <Footer />
            </div>
        </>
    )
}

export default Cdsoft